import { ref } from 'vue'
import {
  chatgptTalk,
  streamSpeaker,
  streamSpeakerNolimit,
  synSpeaker
} from '@/api/chat/index'
import 'element-plus/dist/index.css'
import { formatDate } from '@/utils/index'
import { blobSplit } from '@/utils/data.js'
import { useStore } from 'vuex'
import bus from '@/utils/mitt.js'

import roleHooks from '@/hooks/roleHooks'
import userHooks from '@/hooks/userHooks'

const dellText = (text: any) => {
  // const text = '1. how are you? 2. I like 3.14m swimming. This is a sentence. Another sentence? Yes! And one more... 这是中文句子。这是另一句中文句子？是的！还有一句中文句子……' // Sample text
  const regexEnglish =
    /(?<!\w\.\w\.)(?<!\d\.\d\.)(?<![A-Z][a-z]\.)(?<!Mr\.)(?<!Ms\.)(?<!Mrs\.)(?<!Dr\.)(?<!Prof\.)(?<=\.|\?|\!)\s/
  const regexChinese = /(?<=[。！？])/

  const sentences = text
    .split(regexEnglish)
    .map((sentence: any) => {
      if (regexChinese.test(sentence)) {
        return sentence.split(regexChinese)
      } else {
        return sentence
      }
    })
    .flat()
  const mergedSentences = []
  for (let i = 0; i < sentences.length; i++) {
    if (
      mergedSentences.length > 0 &&
      mergedSentences[mergedSentences.length - 1].length < 10
    ) {
      mergedSentences[mergedSentences.length - 1] += ' ' + sentences[i]
    } else {
      mergedSentences.push(sentences[i])
    }
  }
  // console.log(mergedSentences, 'mergedSentences')
  return mergedSentences
}
const sleep = (delay: any) =>
  new Promise((resolve) => setTimeout(resolve, delay))

export default (audioBuffer: any) => {
  const word = ref('')
  const store = useStore()
  const { curDigitalInfo } = roleHooks()
  const { uuid } = userHooks()
  const dellTextToAudio = async (textArr: any) => {
    for (let i = 0; i < textArr.length; i++) {
      const text = textArr[i]
      await streamSpeaker(
        {
          speaker: store.state?.role?.curDigitalInfo?.magicAudioId,
          selectWord: text
        },
        (audio: any, doneAudio: any) => {
          console.log(text, new Date().getTime() / 1000, '音频流')
          audioBuffer(audio)
        }
      )
      if (textArr.length - 1 == i) {
        await new Promise(() => {
          const uintLength = textArr.length <= 1 ? 16 * 300 * 4 : 16 * 300 * 2
          console.log('ws.send quietAudio !', new Date().getTime() / 1000)
          const u8arr = new Uint8Array(uintLength)
          audioBuffer(u8arr)
          bus.emit('sendStatus', 'end')
        })
      }
    }
  }
  const dellTextToAudioNolimit = async (text: any) => {
    await streamSpeakerNolimit(
      {
        speaker: store.state?.role?.curDigitalInfo?.magicAudioId,
        selectWord: text
      },
      (audio: any, doneAudio: any) => {
        console.log(text, new Date().getTime() / 1000, '音频流')
        audioBuffer(audio)
      }
    )
    await new Promise(() => {
      const uintLength = 16 * 300 * 4
      console.log('ws.send quietAudio !', new Date().getTime() / 1000)
      const u8arr = new Uint8Array(uintLength)
      audioBuffer(u8arr)
      bus.emit('sendStatus', 'end')
    })
  }
  const dellTextToAudioSync = async (textArr: any) => {
    const arrPro = []
    for (let i = 0; i < textArr.length; i++) {
      const text = textArr[i]
      const streamSpeakerRequest = synSpeaker({
        speaker: store.state?.role?.curDigitalInfo?.magicAudioId,
        selectWord: text
      })
      arrPro.push(streamSpeakerRequest)
      // TODO 并发控制处理
    }
    for (let i = 0; i < textArr.length; i++) {
      const audio = await arrPro[i]
      console.log(textArr[i], new Date().getTime() / 1000, '音频流')
      audioBuffer(audio)
      if (textArr.length - 1 == i) {
        await new Promise(() => {
          const uintLength = textArr.length <= 1 ? 16 * 300 * 4 : 16 * 300 * 2
          console.log('ws.send quietAudio !', new Date().getTime() / 1000)
          const u8arr = new Uint8Array(uintLength)
          audioBuffer(u8arr)
          bus.emit('sendStatus', 'end')
        })
      }
    }
  }
  const chatEvent = async (cb?: any) => {
    const paramsSord = word.value
    word.value = ''
    try {
      const data = await chatgptTalk({
        roleId: store.state.role.curSelectRoleInfo.id,
        fileId: store.state.role.curSelectRoleInfo.txtId,
        question: paramsSord,
        session: uuid.value
      })
      // const data = '111111111111111111111111。2222222222222222222222222。3333333333333333333333333。4444444444444444444444444444444444。555555555555555555555555555555555555555。66666666666666666666666666666666666666。7777777777777777777777777777777777777。888888888888888888888888888888888888。999999999999999999999999999999999999。'
      // const data = `作为一个人工智能语言模型，我可以完成许多不同的任务和功能。以下是我可以做的一些事情：
      // 1. 回答问题：我可以回答各种各样的问题，包括学术问题、实用问题、娱乐问题等等。只要输入一个问题，我就会尽力给出最佳答案。
      // 2. 语言翻译：我可以将一种语言翻译成另一种语言。目前，我可以支持多种语言的翻译，包括英语、中文、法语、德语、日语等等。
      // 3. 自然语言处理：我可以对自然语言进行分析和处理，包括语音识别、文本分类、情感分析等等。这些技术可以应用于各种场景，例如智能客服、智能家居等等。
      // 4. 文本生成：我可以生成各种类型的文本，包括新闻报道、小说、诗歌等等。这些文本可以用于各种场景，例如自动写作、内容创作等等。
      // 5. 数据分析：我可以对各种数据进行分析和处理，包括数据挖掘、机器学习、深度学习等等。这些技术可以应用于各种场景，例如金融风控、医疗诊断等等。
      // 总之，我可以做很多事情，但也有一些限制。我不能像人类一样思考和感知，我只能根据输入的信息来生成输出。同时，我也需要不断学习和更新，才能保持最佳状态。`
      bus.emit('sendStatus', 'start')
      cb(data)
      // 不分词 流式
      dellTextToAudioNolimit(data)

      // const textArr = dellText(data)

      // // 分词 流式 tts并发|继发
      // dellTextToAudio(textArr)

      // 分词 异步阻塞 tts并发
      // dellTextToAudioSync(textArr)
    } catch (error: any) {
      cb('', -1)
    }
  }
  return {
    chatEvent,
    word
  }
}
